export const googleSheetURLFormat =
  'https://docs.google.com/spreadsheets/d/{DOCUMENT_ID}/edit#gid={SHEET_ID}' as const
